/* eslint-disable @typescript-eslint/no-explicit-any */
import Layout from '../../common/components/layout/Layout';
import Attributes from '../../common/components/modules/sports/Attributes';
import ContactFondo from '../../common/components/images/sports/futbol/contact.png';

import Contact from '../../common/components/modules/home/Contact';

import Header from '../../common/components/layout/Header';

const Futbol = (): JSX.Element => {
    // const dispatch = useDispatch();
    // const location = useLocation();
    // const pathname = location.pathname.split('/');
    // const sport = pathname.length > 0 ? pathname[1] : 'futbol';

    // /*List Games */
    // const selectListGames = (state: any) => state.listGames;
    // const games = useSelector(selectListGames);
    // const [listDetailsRent, setListDetailsRent] = useState([]);

    // /*List Fields */
    // const selectListFields = (state: any) => state.listFields;
    // const fields = useSelector(selectListFields);
    // const [listDetailsIntegrate, setListDetailsIntegrate] = useState([]);
    // const startHour = format(new Date(), "H':'m");

    // /*List Defys */
    // const selectListDefys = (state: any) => state.listDefys;
    // const defys = useSelector(selectListDefys);
    // const [listDetailsDefy, setListDetailsDefy] = useState([]);

    // useEffect(() => {
    //     dispatch(resetGame);
    //     dispatch(resetStateField);
    //     dispatch(resetStateClub);
    // }, []);

    // useEffect(() => {
    //     dispatch(getGameBysport({ sport, daysLimit: 5, startHour }));
    //     dispatch(getFieldAvailables({ sport, daysLimit: 1, startHour }));
    //     dispatch(getDefyBysport({ sport, daysLimit: 5, startHour }));

    //     dispatch(resetGame);
    //     dispatch(resetStateField);
    //     dispatch(resetStateClub);
    // }, [sport]);

    // useEffect(() => {
    //     if (games && games.data && games.data.data) {
    //         const data = games.data.data;
    //         setListDetailsIntegrate(
    //             data.map((item) => {
    //                 const reservedPlayer = ghostGameTotal(item, sport);
    //                 return {
    //                     id: item.gameId,
    //                     title: `${reservedPlayer}/${item.gameMaxCapacity} CONFIRMADOS`,
    //                     subtitle: `${item.culbName}`,
    //                     day: item.stringDateFormat,
    //                     hrs: `${item.gameHourStart}-${item.gameHourEnd}`,
    //                     commune: item.clubCounty,
    //                     image: item.photo ? item.photo : DefaultImage,
    //                     club: formatPrice(item.gamePricePerPlayer, 0),
    //                     maxCapacity: item.gameMaxCapacity,
    //                     reservedPlayer: reservedPlayer,
    //                 };
    //             }),
    //         );
    //     }
    // }, [games]);

    // useEffect(() => {
    //     if (fields && fields.data && fields.data.data) {
    //         const data = fields.data.data;
    //         setListDetailsRent(
    //             data.map((item) => {
    //                 return {
    //                     id: item.clubId,
    //                     title: `${item.clubName}`,
    //                     day: item.stringDateFormat,
    //                     hrs: `${item.startHour} Hrs.`,
    //                     commune: item.clubCounty,
    //                     image: item.photo ? item.photo : DefaultImage,
    //                     club: '',
    //                     startDate: item.startDate,
    //                 };
    //             }),
    //         );
    //     }
    // }, [fields]);

    // useEffect(() => {
    //     //challengedName es el nombre del desafiado
    //     //challengerName es el nombre del desafiante
    //     //${item.challengeStart}-${item.challengeEnd}
    //     //console.log({ defys });
    //     if (defys && defys.data && defys.data.data) {
    //         const data = defys.data.data;
    //         //${!item.challengedName ? 'Vs' : ''} ${item.challengerName}
    //         setListDetailsDefy(
    //             data.map((item) => {
    //                 const title = `Partido ${item.fieldCapacityBySide}x${item.fieldCapacityBySide} ${item.challengedName} Vs ${item.challengerName}`;
    //                 return {
    //                     id: item.challengeId,
    //                     title: title,
    //                     subtitle: `${item.culbName}`,
    //                     day: item.stringDateFormat,
    //                     hrs: `${item.challengeStart}-${item.challengeEnd}`,
    //                     commune: item.clubCounty,
    //                     image: item.photo ? item.photo : DefaultImage,
    //                     club: formatPrice(item.challengePrice / 2, 0),
    //                     challengeType: item.challengeType,
    //                     challengedName: item.challengedName,
    //                     challengerName: item.challengerName,
    //                     dateFormat: item.challengeDate,
    //                     startDate: item.dateFormat,
    //                 };
    //             }),
    //         );
    //     }
    // }, [defys]);

    // const listDetailsTourney: Array<IDetailsAttribute> = [];

    return (
        <Layout navProps={{ title: 'Futbol | Supermatch', description: 'Supermatch' }}>
            <>
                <Header />
                <Attributes />
                {/* <SliderSport
                    attribute={attributesBySport('rent')}
                    details={listDetailsRent}
                    loading={fields.isLoading}
                />
                <SliderSport
                    attribute={attributesBySport('integrate')}
                    details={listDetailsIntegrate}
                    loading={games.isLoading}
                />
                <SliderSport attribute={attributesBySport('defy')} details={listDetailsDefy} loading={false} />
                <SliderSport attribute={attributesBySport('tourney')} details={listDetailsTourney} loading={false} /> */}
                <Contact background={ContactFondo} />
                {/* <StepsPlay /> */}
            </>
        </Layout>
    );
};

export default Futbol;
